import { useTheme } from '@emotion/react'
import { NextSeo } from 'next-seo'

import TermAndPrivacyLayout from '@/modules/termsAndPrivacy/components/TermAndPrivacyLayout'
import { renderTemplate } from '@/modules/termsAndPrivacy/helpers'

import { MainLayout } from '@/layouts/MainLayout'

const TYPE = 'privacy'

export function PrivacyPolicy(): React.ReactElement {
  const theme = useTheme()

  return (
    <>
      <NextSeo title="Privacy Policy" />
      <TermAndPrivacyLayout>
        <h1>นโยบายความเป็นส่วนตัว</h1>
        <p>
          นโยบายความเป็นส่วนตัวฉบับนี้ (&quot;นโยบาย&quot;) อธิบายถึงวิธีการที่
          Consent Wow (&quot;บริษัท เอ็นเดต้าธอธ จำกัด&quot; หรือ
          &quot;เรา&quot;) เก็บรวบรวม ใช้ และเปิดเผย ข้อมูลส่วนบุคคล
          (&quot;ข้อมูลส่วนบุคคล&quot;) ที่ท่าน (&quot;ผู้ใช้&quot; หรือ
          &quot;ท่าน&quot;) ได้ให้สำหรับการใช้งานเว็บไซต์ Consent Wow
          และผลิตภัณฑ์หรือบริการดังกล่าว (เรียกรวมกันว่า &quot;เว็บไซต์ Consent
          Wow&quot; หรือ &quot;บริการ&quot;)
          เพื่อให้สอดคล้องกับพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
          (&quot;PDPA&quot;)
          ซึ่งรวมไปถึงการอธิบายในตัวเลือกสำหรับท่านที่เกี่ยวข้องกับการใช้ข้อมูลส่วนบุคคลของท่านและวิธีการให้ท่านเข้าถึงข้อมูลหรือทำให้ข้อมูลเป็นปัจจุบัน
          นโยบายฉบับนี้ไม่บังคับใช้กับการปฏิบัติงานของบริษัทที่เราไม่ได้เป็นผู้ดูแลหรือบุคคลที่เราไม่ได้มีการจ้างหรือต้องจัดการ
        </p>
        {renderTemplate(TYPE)}
        <br />
        <hr />
        <br />
        <p
          id="end-content"
          css={theme.mq({ fontWeight: '--fontWeights-medium' })}
        >
          เอกสารฉบับนี้ปรับปรุงล่าสุดเมื่อวันที่ 29 สิงหาคม 2565
        </p>
      </TermAndPrivacyLayout>
    </>
  )
}

PrivacyPolicy.getLayout = function getLayout(page: React.ReactNode) {
  return <MainLayout>{page}</MainLayout>
}
